export interface SmsRemainingCreditPayloadModel {
  smsCredit: number;
}
